module.exports = __webpack_public_path__ + "static/media/opening_12.87b05f52.webp";